import {
  parseDate
} from "./chunk-KPPABCK2.mjs";

// src/date/month.ts
var startOfMonth = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
};
var endOfMonth = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
};
var daysInMonth = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
};

export {
  startOfMonth,
  endOfMonth,
  daysInMonth
};
//# sourceMappingURL=chunk-KS7FW3HF.mjs.map